import '../style.scss';
import { BankDetailsInput } from 'views/templates/module/bankDetailsInput';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { useBankInfo } from './hooks';
import { TemplateProps } from '../common';
import { useCustomLocationName } from 'views/mutual/location/hooks';

export type BankInfoProps = {
  formik: any;
  bankDetailsInfoProps: any;
};

export const BankInfoWrapper = () => {
  return <BankInfo {...useBankInfo({ isUpdate: false })} />;
};

export const BankInfo = ({
  formik,
  bankDetailsInfoProps,
  isUpdate,
}: BankInfoProps & TemplateProps) => {
  useCustomLocationName('口座開設申込みフォーム');

  return (
    <form onSubmit={formik.handleSubmit} className="personalAccountOpenTemplate">
      <div className="personalAccountOpenTemplate_input">
          <FormContentHeader label={`配当金振込用口座${isUpdate ? '（国内不動産）' : ''}`} formType={FormType.Optional} />
          <div className="personalAccountOpenTemplate_input_wrapper">
             <BankDetailsInput name="bankInput" {...bankDetailsInfoProps}/>
          </div>
      </div>      
    </form>
  );
};
